import { Component, Vue } from 'vue-property-decorator';
import { FileFieldEnum, MaxFileEnum } from './types';

@Component({
  components: {
    File: () => import('@/pages/profile/blocks/form/components/file'),
  },
})
export default class FileInputMixin extends Vue {
  fileWarnings: string = '';
  resultForm: any = {};

  inputFile($events: any) {
    const [files] = $events.target.files;
    //в type не записывается тип файла, когда документ .doc или .docx поэтому пока что нашел решение проверять расширение файла
    const allowedTypes =
      [
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword',
      ].includes(files.type) ||
      files.name.endsWith('.doc') ||
      files.name.endsWith('.docx');
    const toLarge = files.size > MaxFileEnum.MAX_FILE;
    if (allowedTypes && !toLarge) {
      this.resultForm.files = files;
      this.fileWarnings = '';
    } else {
      this.fileWarnings =
        allowedTypes && toLarge
          ? FileFieldEnum.MAX_VOLUME
          : FileFieldEnum.FILE_FORMAT;
      this.resultForm.files = { name: '' };
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/mixins/FileInputMixin.ts